<template>
    <div>
        <div>
            <vue-headful :title="$t('title_profile')" description="title" />
        </div>
        <Snackbar :top="false" :bottom="true" />
        <v-container fluid fill-height>
            <v-row class="mx-1">
                <TopBar />
                <Banner />
                <Summary />
                <Abilities
                    :progress="skills"
                    @onChangeDateRange="onChangeDateRange"
                    :progressReady="progressReady"
                />
            </v-row>
        </v-container>
    </div>
</template>
<script>
import { mapState, mapActions } from 'vuex'
import * as Sentry from '@sentry/vue'
import Abilities from '@/components/profile/Abilities.vue'
import Achievements from '@/components/profile/Achievements.vue'
import Banner from '@/components/profile/Banner.vue'
import Collection from '@/components/profile/Collection.vue'
import GlobalProgress from '@/components/profile/GlobalProgress.vue'
import Store from '@/components/profile/Store.vue'
import Summary from '@/components/profile/Summary.vue'
import StudentCode from '@/components/profile/StudentCode.vue'
import TopBar from '@/components/home/TopBar.vue'
import Snackbar from '@/components/core/Snackbar.vue'
import GamificationService from '../../services/gamification'
import UsersServices from '../../services/users'
import ReportService from '../../services/report'

import AnalyticEventsMixin from "@/mixins/analyticEvents"
import timeTrackerMixin from '@/mixins/timeTrackerMixin'

import { AnalyticEventTypes } from '@/constants/AnalyticEventTypes'


const defaultSkills = {
    index: 0,
    localizar: 0,
    reflexionar: 0,
    integrar: 0
}

export default {
    computed: {
        ...mapState({
            user: (state) => state.userData.user
        }),
    },
    components: {
        Abilities,
        Achievements,
        Banner,
        Collection,
        GlobalProgress,
        Store,
        Summary,
        TopBar,
        StudentCode,
        Snackbar
    },
    mixins: [AnalyticEventsMixin, timeTrackerMixin],
    data() {
        return {
            skills: defaultSkills,
            studentCode: '',
            progressReady: true,
        }
    },
    created() {
        const startDate = this.$moment().subtract(7, 'days').format('YYYY-MM-DD')
        const endDate = this.$moment().format('YYYY-MM-DD')
        this.getGeneralInformationForStudent(
            startDate,
            endDate,
        )
        this.getGamification()
        this.getStudentCode()
    },
    mounted() {
        this.createAnalyticEvent(AnalyticEventTypes.VisitedProfile)
    },
    methods: {
        ...mapActions('userData', [
            'setGamification',
        ]),
        onChangeDateRange(daysAgo) {
            const currentDate = this.$moment()
            const endDate = currentDate.format('YYYY-MM-DD')
            const startDate = currentDate.subtract(daysAgo, 'days').format('YYYY-MM-DD')
            this.getGeneralInformationForStudent(startDate, endDate)
        },
        getGeneralInformationForStudent(startDate, endDate) {
            this.progressReady = false
            ReportService.getGeneralInformationForStudent(
                this.user.id,
                this.user.course.id,
                startDate,
                endDate,
            )
            .then((response) => {
                const { studentsList } = response.content
                if (studentsList && Array.isArray(studentsList) && studentsList.length > 0) {
                    this.setAbilities(studentsList[0].bookAndChallengeDTO)
                }
            })
            .catch((error) => console.error(error))
            .finally(() => {
                this.progressReady = true
            })
        },
        getGamification() {
            GamificationService.getUserGameStatsByUser(
                this.user.id
            )
            .then((response) => {
                if (response.content.id) {
                    this.setGamification(response.content)
                }
            })
            .catch((error) => console.error(error))
        },
        getStudentCode() {
            UsersServices.getStudentCode(this.user.id)
                .then(resp => { this.studentCode = resp.content.codeToAssociate })
                .catch(err => Sentry.captureException(err))
        },
        setAbilities(data) {
            this.skills = data
        }
    }
}
</script>
